<div class="page-body-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div class="button-container">
                <button mat-flat-button color="primary"  (click)="openLookupCreateModal()">
                    <mat-icon>add</mat-icon>
                    <span>Yeni Tanım Ekle</span>
                </button>
            </div>

            <div class="table-responsive">
                <mat-form-field style="width: 100%">
                    <mat-label>Arama</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="">
                </mat-form-field>
                <mat-table class="lessons-table mat-elevation-z8" [dataSource]="dataSource" style="width: 100%">
                    <ng-container matColumnDef="parentvalue">
                        <mat-header-cell *matHeaderCellDef> Ana Lookup </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.parentvalue}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="lookupCode">
                        <mat-header-cell *matHeaderCellDef> Kod </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.lookupCode}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="lookupValue">
                        <mat-header-cell *matHeaderCellDef> Değer </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.lookupValue}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef> Açıklama </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.description}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let element" class="actions-mat-cell" style="flex-grow: 1 !important;">
                            <button mat-icon-button matTooltip="Güncelle" class="lookup-iconbutton iconbutton action-edit-button"
                                (click)="openUpdateModal(element)">
                                <mat-icon class="lookup-action-icon" aria-label="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Sil" class="lookup-iconbutton iconbutton action-delete-button"
                                (click)="openDeleteModal(element)">
                                <mat-icon class="lookup-action-icon" aria-label="delete">delete_forever</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row class="lookup-table-header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns" class="lookup-table-row"></mat-row>
    
                </mat-table>
                <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" showFirstLastButtons></mat-paginator>

            </div>
        </div>
    </div>
</div>
